var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.54.55c-.74.7-7.95 8.1-7.95 8.1C4.2 9.01 4 9.5 4 10s.2.98.6 1.36c0 0 7.2 7.4 7.94 8.1.73.7 2.06.75 2.85 0 .78-.75.85-1.8 0-2.72L8.77 10l6.62-6.74c.85-.92.78-1.96 0-2.71a2.13 2.13 0 0 0-2.85 0"
})));
export default SvgChevronLeft;